import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchReportDetails } from './action'
import {
    Row, Col, Breadcrumb, BreadcrumbItem, Card, CardBody, CardHeader,
    Button, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem
} from 'reactstrap';
import moment from 'moment';
import PdfView from '../../components/ReusableComponents/SurveyView/index';
// import speedometer from '../../assets/images/speedometer-bg.png';
import './report.scss';
import { viewPublishedReport } from '../../Analyst/Cases/View/action';
// import ReactSpeedometer from "react-d3-speedometer";
import CanvasMeter from 'canvas-meter';
import { LONG_DATE_FORMAT, CURRENCY_FORMAT_FULL_FIGURES, CURRENCY_FORMAT_LAKH, CURRENCY_FORMAT_MN, CURRENCY_FORMAT_BN, CURRENCY_FORMAT_K, CURRENCY_FORMAT_CR } from '../../constants';
import RiskGradePopover from './popover';
import { getSpeedoSkin } from './speedometerconfig';
import { getSpeedometerValues } from './helper';
class Report extends Component {
    constructor() {
        super();
        this.state = {
            fetchPdf: null,
            riskGradeData: [],
            popoverOpen: false,
            authCapCurrencyFormatDropdownOpen: false,
            paidupCapCurrencyFormatDropdownOpen: false,
            authCapSelectedCurrencyFormat: CURRENCY_FORMAT_FULL_FIGURES,
            paidupCapSelectedCurrencyFormat: CURRENCY_FORMAT_FULL_FIGURES,
            authCap: "",
            paidupCap: "",
            speedometer: null
        }
    }
    componentDidMount() {
        this.props.fetchReportDetails(this.props.match.params.id);
    }
    componentDidUpdate(prevProps) {
        const { counterPartyReportDetails, fetchPdf } = this.props
        if (counterPartyReportDetails !== prevProps.counterPartyReportDetails) {
            // var animation = new Animation();
            this.props.viewPublishedReport(counterPartyReportDetails.computedReportId);
            const meterValues = getSpeedometerValues(counterPartyReportDetails);
            const meter = new CanvasMeter(document.getElementById("meter"));
            meter.draw(meterValues.totalScore, meterValues.min, meterValues.max, 45, 45);
            meter.setOptions(getSpeedoSkin(meterValues));
            this.setState({
                riskGradeData: counterPartyReportDetails.riskGradeSummaryList,
                authCap: this.formatCurrency(counterPartyReportDetails.authorizedCapital),
                paidupCap: this.formatCurrency(counterPartyReportDetails.paidUpCapital),
                speedometer: meter
            })
        }
        if (fetchPdf.error && fetchPdf !== prevProps.fetchPdf) {
            if (fetchPdf.error) {
                this.setState({
                    fetchPdf: <span className="text-danger">{(fetchPdf.error.response && fetchPdf.error.response.data) ? fetchPdf.error.response.data.message : "Something went wrong! Please try again."}</span>
                })
            }
        } else if (fetchPdf.data && fetchPdf !== prevProps.fetchPdf) {
            const temp = {
                sesectionData: '',
                pdfUrl: fetchPdf.data
            }
            this.setState({
                fetchPdf: <PdfView {...temp} />
            })
        }
    }

    riskGradesPopoverToggle = () => {
        this.setState((prevState) => ({
            popoverOpen: !prevState.popoverOpen
        }))
    }

    formatCurrency = (number, decimalDigits = 2) => {
        return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: decimalDigits }).format(number);
    }

    authCapCurrencyDropdownToggleHandler = () => {
        this.setState((prevState) => ({
            authCapCurrencyFormatDropdownOpen: !prevState.authCapCurrencyFormatDropdownOpen
        }));
    }

    paidupCapCurrencyDropdownToggleHandler = () => {
        this.setState((prevState) => ({
            paidupCapCurrencyFormatDropdownOpen: !prevState.paidupCapCurrencyFormatDropdownOpen
        }));
    }

    authCapCurrencyFormatChangeHandler = (event) => {
        let authCap = "";
        let propAuthCap = this.props.counterPartyReportDetails.authorizedCapital;
        switch (event.target.innerText) {
            case CURRENCY_FORMAT_K:
                authCap = this.formatCurrency(Number(propAuthCap) / 1000);
                break;
            case CURRENCY_FORMAT_LAKH:
                authCap = this.formatCurrency(Number(propAuthCap) / 100000);
                break;
            case CURRENCY_FORMAT_CR:
                authCap = this.formatCurrency(Number(propAuthCap) / 10000000);
                break;
            case CURRENCY_FORMAT_MN:
                authCap = this.formatCurrency(Number(propAuthCap) / 1000000);
                break;
            case CURRENCY_FORMAT_BN:
                authCap = this.formatCurrency(Number(propAuthCap) / 1000000000);
                break;
            case CURRENCY_FORMAT_FULL_FIGURES:
            default:
                authCap = this.formatCurrency(propAuthCap, 0);
        }
        this.setState({
            authCapSelectedCurrencyFormat: event.target.innerText,
            authCap: authCap
        });
    }

    paidupCapCurrencyFormatChangeHandler = (event) => {
        let paidupCap = "";
        let propPaidupCap = this.props.counterPartyReportDetails.paidUpCapital;
        switch (event.target.innerText) {
            case CURRENCY_FORMAT_K:
                paidupCap = this.formatCurrency(Number(propPaidupCap) / 1000);
                break;
            case CURRENCY_FORMAT_LAKH:
                paidupCap = this.formatCurrency(Number(propPaidupCap) / 100000);
                break;
            case CURRENCY_FORMAT_CR:
                paidupCap = this.formatCurrency(Number(propPaidupCap) / 10000000);
                break;
            case CURRENCY_FORMAT_MN:
                paidupCap = this.formatCurrency(Number(propPaidupCap) / 1000000);
                break;
            case CURRENCY_FORMAT_BN:
                paidupCap = this.formatCurrency(Number(propPaidupCap) / 1000000000);
                break;
            case CURRENCY_FORMAT_FULL_FIGURES:
            default:
                paidupCap = this.formatCurrency(propPaidupCap, 0);
        }
        this.setState({
            paidupCapSelectedCurrencyFormat: event.target.innerText,
            paidupCap: paidupCap
        });
    }

    render() {
        let riskDescription;
        if (this.props.counterPartyReportDetails.riskGradeSummaryList) {
            let riskGradeElement = this.props.counterPartyReportDetails.riskGradeSummaryList.find((elem) => {
                return elem.riskGrade === this.props.counterPartyReportDetails.computedRiskGrade
            });
            if (riskGradeElement) {
                riskDescription = riskGradeElement.riskDescription;
            }
        }
        return (
            <Col className="report">
                <Breadcrumb className="mb-3">
                    <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                    <BreadcrumbItem><Link to="/my-portfolio/1">Case Portfolio</Link></BreadcrumbItem>
                    <BreadcrumbItem active>Report</BreadcrumbItem>
                </Breadcrumb>
                <Row>
                    <Col className="p-0 p-sm-3">
                        <Card>
                            <CardHeader className="report-header d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center">
                                <h5 className="mb-1 mb-sm-0">{this.props.counterPartyReportDetails.companyName}</h5>
                                <div className="last-update">
                                    <label className="mb-0">Last Updated:&nbsp;</label>
                                    <span>{moment(this.props.counterPartyReportDetails.lastUpdatedAt).format(LONG_DATE_FORMAT)}</span>
                                </div>
                            </CardHeader>
                            <CardBody>
                                <Row noGutters className="mb-3 border">
                                    <Col xs="24" sm="10" className="report-block">
                                        <Card className="h-100">
                                            <CardHeader className="bg-light report-block-header d-flex justify-content-between">
                                                <h4>Rubix Risk Score</h4>
                                                <Button size="sm" color="link" onClick={this.riskGradesPopoverToggle} id="Popover1">
                                                    <i className="icon-info"></i>
                                                </Button>
                                                <RiskGradePopover
                                                    riskGradeData={this.state.riskGradeData}
                                                    popoverOpen={this.state.popoverOpen}
                                                    toggle={this.riskGradesPopoverToggle}
                                                    highlighted={this.props.counterPartyReportDetails.computedRiskGrade} />
                                            </CardHeader>
                                            <CardBody className="report-block-body">
                                            <div className="speedometer-wrapper" style={{textAlign: 'center'}}>
                                                    <canvas  height="250" id="meter"></canvas>
                                                    {/* <ReactSpeedometer
                                                        maxValue={100}
                                                        value={this.props.counterPartyReportDetails.totalScore}
                                                        needleColor="grey"
                                                        startColor="red"
                                                        segments={3}
                                                        endColor="green"
                                                        textColor="grey"
                                                        ringWidth={40}
                                                        needleHeightRatio={0.7}
                                                    /> */}
                                                    {/* <div className="needle-cover m-auto">
                                                        <span className="risk-score text-center w-100 d-block">{(this.props.counterPartyReportDetails.totalScore) ? Math.round(this.props.counterPartyReportDetails.totalScore) : '-'}</span>
                                                    </div> */}
                                                </div>
                                                <div className="text-center title mt-3">
                                                    {this.props.counterPartyReportDetails.computedRiskGrade}&nbsp; &nbsp; ({riskDescription})
                                                </div>
                                                {/* <div className="text-center title mt-3">
                                                    {riskDescription}
                                                </div> */}
                                                {/* <div className="speedometer-wrapper">
                                                    <div className="speedometer">
                                                        <div className="needle-box">
                                                            <span id="needle" className="needle"></span>
                                                        </div>
                                                        <div className="needle-cover">
                                                            <span className="risk-score">{this.props.counterPartyReportDetails.totalScore}</span>
                                                        </div>
                                                    </div>
                                                    <div className="text-center title mt-3">
                                                        AVERAGE COUNTERPARTY RISK
                                                    </div>
                                                </div> */}
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col xs="24" sm="8" className="report-block border-xs-top border-sm-left">
                                        <Card className="h-100">
                                            <CardHeader className="bg-light report-block-header">
                                                <h4>Company Description</h4>
                                            </CardHeader>
                                            <CardBody className="report-block-body">
                                                <p>
                                                    {this.props.counterPartyReportDetails.companyDesc}
                                                </p>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col xs="24" sm="6" className="report-block border-xs-top border-sm-left">
                                        <Card className="h-100">
                                            <CardHeader className="bg-light report-block-header">
                                                <h4>Activity</h4>
                                            </CardHeader>
                                            <CardBody className="report-block-body">
                                                <p>{this.props.counterPartyReportDetails.companyActivity}</p>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col>
                                        <Card>
                                            <CardHeader className="report-sub-header">
                                                <h6>Business Facts</h6>
                                            </CardHeader>
                                            <CardBody className="py-0 border border-top-0">
                                                <Row>
                                                    <Col xs="24" sm="9" md="12" lg="9" className="report-block py-3 col-9">
                                                        <ul>
                                                            <li className="d-flex justify-content-between">
                                                                <label className="w-60 report-block-title">Class of Company</label>
                                                                <span className="w-40 report-block-value text-right">{this.props.counterPartyReportDetails.classOfCompany}</span>
                                                            </li>
                                                            <li className="d-flex justify-content-between">
                                                                <label className="w-60 report-block-title">Company Status</label>
                                                                <span className="w-40 report-block-value text-right">{this.props.counterPartyReportDetails.companyStatus}</span>
                                                            </li>
                                                            <li className="d-flex justify-content-between">
                                                                <label className="w-60 report-block-title">Date of Incorporation</label>
                                                                <span className="w-40 report-block-value text-right">{this.props.counterPartyReportDetails.dateOfIncorporation}</span>
                                                            </li>
                                                            <li className="d-flex justify-content-between">
                                                                <label className="w-60 report-block-title">Date of Last Balance sheet</label>
                                                                <span className="w-40 report-block-value text-right">{this.props.counterPartyReportDetails.lastBalanceSheetDate}</span>
                                                            </li>
                                                            <li className="d-flex justify-content-between">
                                                                <label className="w-60 report-block-title">Date of Last Annual General meeting</label>
                                                                <span className="w-40 report-block-value text-right">{this.props.counterPartyReportDetails.lastGeneralMeetingDate}</span>
                                                            </li>
                                                        </ul>
                                                    </Col>
                                                    <Col xs="24" sm="4" md="12" lg="4" className="report-block col-4 px-0 py-3 text-center border-xs-top border-sm-left">
                                                        <div className="d-flex flex-column border-bottom p-3 h-50 justify-content-center">
                                                            <label className="report-block-title">Authorized Capital</label>
                                                            <span className="capital-value report-block-value">
                                                                {this.state.authCap}
                                                            </span>
                                                            <ButtonDropdown isOpen={this.state.authCapCurrencyFormatDropdownOpen} toggle={this.authCapCurrencyDropdownToggleHandler} direction="down" className="align-items-center">
                                                                <DropdownToggle caret color="link" block>
                                                                    {this.state.authCapSelectedCurrencyFormat}
                                                                </DropdownToggle>
                                                                <DropdownMenu>
                                                                    <DropdownItem onClick={this.authCapCurrencyFormatChangeHandler} className="p-3">{CURRENCY_FORMAT_FULL_FIGURES}</DropdownItem>
                                                                    <DropdownItem onClick={this.authCapCurrencyFormatChangeHandler} className="p-3">{CURRENCY_FORMAT_K}</DropdownItem>
                                                                    <DropdownItem onClick={this.authCapCurrencyFormatChangeHandler} className="p-3">{CURRENCY_FORMAT_LAKH}</DropdownItem>
                                                                    <DropdownItem onClick={this.authCapCurrencyFormatChangeHandler} className="p-3">{CURRENCY_FORMAT_CR}</DropdownItem>
                                                                    <DropdownItem onClick={this.authCapCurrencyFormatChangeHandler} className="p-3">{CURRENCY_FORMAT_MN}</DropdownItem>
                                                                    <DropdownItem onClick={this.authCapCurrencyFormatChangeHandler} className="p-3">{CURRENCY_FORMAT_BN}</DropdownItem>
                                                                </DropdownMenu>
                                                            </ButtonDropdown>
                                                        </div>
                                                        <div className="d-flex flex-column p-3 h-50 justify-content-center">
                                                            <label className="report-block-title">Paid up Capital</label>
                                                            <span className="capital-value report-block-value">
                                                                {this.state.paidupCap}
                                                            </span>
                                                            <ButtonDropdown isOpen={this.state.paidupCapCurrencyFormatDropdownOpen} toggle={this.paidupCapCurrencyDropdownToggleHandler} direction="down" className="align-items-center">
                                                                <DropdownToggle caret color="link" block>
                                                                    {this.state.paidupCapSelectedCurrencyFormat}
                                                                </DropdownToggle>
                                                                <DropdownMenu>
                                                                    <DropdownItem onClick={this.paidupCapCurrencyFormatChangeHandler} className="p-3">{CURRENCY_FORMAT_FULL_FIGURES}</DropdownItem>
                                                                    <DropdownItem onClick={this.paidupCapCurrencyFormatChangeHandler} className="p-3">{CURRENCY_FORMAT_K}</DropdownItem>
                                                                    <DropdownItem onClick={this.paidupCapCurrencyFormatChangeHandler} className="p-3">{CURRENCY_FORMAT_LAKH}</DropdownItem>
                                                                    <DropdownItem onClick={this.paidupCapCurrencyFormatChangeHandler} className="p-3">{CURRENCY_FORMAT_CR}</DropdownItem>
                                                                    <DropdownItem onClick={this.paidupCapCurrencyFormatChangeHandler} className="p-3">{CURRENCY_FORMAT_MN}</DropdownItem>
                                                                    <DropdownItem onClick={this.paidupCapCurrencyFormatChangeHandler} className="p-3">{CURRENCY_FORMAT_BN}</DropdownItem>
                                                                </DropdownMenu>
                                                            </ButtonDropdown>
                                                        </div>
                                                    </Col>
                                                    <Col xs="24" sm="6" md="12" lg="6" className="report-block col-6 profile py-3 border-xs-top border-sm-left border-md-left-0 border-md-top border-lg-top-0 border-lg-left">
                                                        {/*  <div className="border avatar">
                                                            <i className="icon-user"></i>
                                                        </div> */}
                                                        <div className="profile-details d-flex flex-column">
                                                            <ul>
                                                                <li className="mb-4">
                                                                    <label className="d-block report-block-title mb-1">Company Number</label>
                                                                    <span className="d-block report-block-value">{this.props.counterPartyReportDetails.companyNumber}</span>
                                                                </li>
                                                                <li className="mb-4">
                                                                    <label className="d-block report-block-title mb-1">Email</label>
                                                                    <span className="d-block report-block-value">{this.props.counterPartyReportDetails.companyEmail}</span>
                                                                </li>
                                                                <li className="mb-4">
                                                                    <label className="d-block report-block-title mb-1">Website</label>
                                                                    <span className="d-block report-block-value">{this.props.counterPartyReportDetails.companyWebsite}</span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </Col>
                                                    <Col xs="24" sm="5" md="12" lg="5" className="report-block address py-3 border-xs-top border-sm-left border-md-top border-lg-top-0 border-lg-left">
                                                        <address className="d-flex flex-column">
                                                            <span className="name">{this.props.counterPartyReportDetails.companyName}</span>
                                                            <span>{this.props.counterPartyReportDetails.companyAddress}</span>
                                                            {/* <span>101, 1st Floor, Centre Point,</span>
                                                            <span>Dr. Babasaheb Ambedkar Road,</span>
                                                            <span>Parel , Mumbai - 400012</span>
                                                            <span>Maharashtra India</span> */}
                                                        </address>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Card>
                                            <CardHeader className="report-sub-header">
                                                <h6>Report</h6>
                                            </CardHeader>
                                            <CardBody className="border border-top-0">
                                                <section>
                                                    {this.state.fetchPdf}
                                                </section>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Col>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    counterPartyReportDetails: state.reportCorporate.reportDetails,
    fetchPdf: state.section.viewCompletedReportPdf
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchReportDetails: (id) => { dispatch(fetchReportDetails(id)) },
    viewPublishedReport: (id) => { dispatch(viewPublishedReport(id)) }
});
export default Report = connect(
    mapStateToProps,
    mapDispatchToProps
)(Report)
